import { StorageService } from './core/services/storage.service';
import { Component, HostListener, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { AuthService, IdleDetectService } from './core/services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { InfoModalComponent } from './core/modal/info-modal/info-modal.component';
import CONSTANTS from './core/constants';

declare function logar_chat(isProduction: boolean): any;
declare function hidden_button(): any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  constructor(
    translate: TranslateService,
    private idleDetectService: IdleDetectService,
    private modalService: NgbModal,
    private storageService: StorageService,
    private router: Router,
    private authService: AuthService,
  ) {
    translate.addLangs(['pt-br', 'en']);
    translate.setDefaultLang('pt-br');

    const browserLang: string = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr/) ? browserLang : 'pt-br');
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event) {
    localStorage.setItem('pageClosedAt', new Date().toString());
  }

  ngOnInit() {
    this.idleDetectService.setTimer(CONSTANTS.CONFIG_USER_IDLE.IDLE, CONSTANTS.CONFIG_USER_IDLE.TIMEOUT);

    this.authService.getUserLoggedIn().subscribe(userLoggedIn => {
      if (userLoggedIn) {
        // Iniciar o serviço de ociosidade
        this.idleDetectService.startTimer();
      } else {
        // Pausar o serviço de ociosidade
        this.idleDetectService.stopTimer();
      }
    });

    const user = this.storageService.getUser();
    const pageClosedAt = this.storageService.getPageClosedAt();

    if (user && user._id) {
      logar_chat(environment.production);

      if (pageClosedAt) {
        if (this.calculateDateDiffInSeconds(pageClosedAt) > CONSTANTS.CONFIG_USER_IDLE.IDLE) {
          this.logout();
        } else {
          this.authService.setUserLoggedIn(true);
        }
      } else {
        this.authService.setUserLoggedIn(true);
      }
    } else {
      this.authService.setUserLoggedIn(false);
    }

    this.idleDetectService.watcherIdle().subscribe((res) => {
      if (res) {
        this.idleDetectService.onTimeout();
        this.openInfoModal();
      }
    });

    this.idleDetectService.watcherTimeout().subscribe((res) => {
      if (res) {
        this.logout();
        this.modalService.dismissAll();
      }
    });
  }

  calculateDateDiffInSeconds(date: string) {
    const specificDate = new Date(date);

    const diffInMilliseconds = Date.now() - specificDate.getTime();

    return (Math.floor(diffInMilliseconds / 1000));
  }

  openInfoModal() {
    const modal = this.modalService.open(InfoModalComponent, { backdrop: 'static', keyboard: false });
    modal.componentInstance.title = 'Sua sessão expirou';
    modal.componentInstance.text = 'Você ainda está aqui?';
    modal.componentInstance.btnFail = 'Sair da conta';
    modal.componentInstance.btnSuccess = 'Permanecer conectado';

    modal.result.then(result => {
      if (result) {
        this.idleDetectService.resetTimeout();
        this.idleDetectService.resetTimer();
      } else {
        this.logout();
        this.modalService.dismissAll();
      }
    }).catch(err => { });
  }

  logout() {
    this.authService
      .logout()
      .subscribe(() => {
        hidden_button();
        this.router.navigate(['/auth/signin']);
      });
  }
}
